"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindIntegrationsResponse = exports.FindIntegrationsQuery = exports.ConnectionMode = void 0;
const tslib_1 = require("tslib");
const entity_repository_1 = require("../entity-repository");
tslib_1.__exportStar(require("./api"), exports);
tslib_1.__exportStar(require("./accessors"), exports);
var ConnectionMode;
(function (ConnectionMode) {
    ConnectionMode["POPUP"] = "popup";
    ConnectionMode["IFRAME"] = "iframe";
})(ConnectionMode = exports.ConnectionMode || (exports.ConnectionMode = {}));
class FindIntegrationsQuery extends entity_repository_1.PaginationQuery {
}
exports.FindIntegrationsQuery = FindIntegrationsQuery;
class FindIntegrationsResponse extends entity_repository_1.PaginationResponse {
}
exports.FindIntegrationsResponse = FindIntegrationsResponse;
//# sourceMappingURL=index.js.map